import { loadDisableAds } from "utils/storage";

export const isDisableAds = () => {
  return loadDisableAds() === "yes";
};
